import Vue from 'vue'
import ElementUI from 'element-ui';
import axios from 'axios'
// import localStorage from '../vuex/localStorage'
import qs from 'qs';
import {rootUrl} from '@/config'
import {router} from "../router";
import util from "@/common/js/util";
import constants from "@/common/constants";
let apiPrefix = process.env.NODE_ENV === 'production' ? '/' : '/api';
let version = process.env.version;
let lzPageTime = (Math.round(new Date().getTime() / 1000)).toString(36);

console.log({version, lzPageTime});

let AxiosIns = axios.create({
	baseURL: rootUrl,
	timeout: 5000,
	transformRequest: [data => {
		if(!data){
			data = {};
		}
		data.requestMeta = `v=${version};t=${lzPageTime};lo=1`;
		if (!data.companyId) {
			data.companyId = constants.company.companyId;
		}
		return qs.stringify(data)
	}],
	headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8','client-version':version },
	withCredentials: true
});

let AxiosIns2 = axios.create({
	baseURL: rootUrl,
	timeout: 50000,
	withCredentials: true,
	headers:          {'Content-Type': 'application/json','client-version':version},
	transformRequest: [data => {
		if(!data){
			data.requestMeta = `v=${version};t=${lzPageTime};lo=1`;
		}
		if (!data.companyId) {
			data.companyId = constants.company.companyId;
		}
		return JSON.stringify(data);
	}],
});

let timer = [];
let delay = 300;
let loading = null;
let options = {
	lock: true,
	text: '拼命加载中',
	background: 'rgba(0, 0, 0, 0)'
}
let julietJava = "juliet-java";

let msgSet = new Set();

[AxiosIns,AxiosIns2].forEach(AxiosIns=>{
	AxiosIns.interceptors.request.use((config) => {
		if(config.loading !== false){
			loading = ElementUI.Loading.service(options);
			timer.push(setTimeout(() => {}, delay))
		}
		return config;
	})

	AxiosIns.interceptors.response.use((response) => {
		if (response.headers[julietJava]){
			localStorage.$setLocalStorageByName(julietJava,response.headers[julietJava]);
		}
		for (let t of timer) {
			clearTimeout(t);
		}
		loading?.close();
		try {//使用try catch是因为：后台服务器挂掉返回的并不是一个object并不能正确捕捉到错误信息
			if (response.data && response.data.success !== true) {
				let msg = Array.isArray(response.data.errMsg) ? response.data.errMsg[0] : response.data.errMsg;
				let message = msg || '操作失败';
				if (!msgSet.has(message)) {
					msgSet.add(message);
					window.setTimeout(() => {
						if (msgSet.has(message)) {
							msgSet.delete(message);
						}
					}, 3000);
					if (message.length < 60) {
						ElementUI.Message({message,type: 'warning',showClose: true});
					}else{
						// 消息内容太长的话，自动换行
						ElementUI.Message({
							message:`<div style="max-width: 600px;white-space: pre-line;word-break: break-word;">${message}</div>`,
							dangerouslyUseHTMLString: true,
							type: 'warning',
							duration: 5000,
							showClose: true
						});
					}
				}
				if (["LOGIN_ERROR","LOGIN_TIME_OUT"].includes(response.data.errCode)) { // cookie验证验权失败
					for (var key in localStorage) {
						if (key !== "clientCompanyInfo") {
							localStorage.removeItem(key);
						}
					}
					router.push({path: "/login"});
					return ;
				}
			}
		} catch (e) {
			console.log(e);
		}
		return response.data;
	}, (error) => {
		for (let t of timer) {
			clearTimeout(t);
		}
		loading?.close();
		try {
			// 请求授权失败则重新跳转到登录页
			if (error.response.data.Code === 401) {
				setTimeout(() => {
					router.push({
						name: 'login'
					})
				}, 2000)
			}
		} catch (e) {
			console.log(e);
		}
		return Promise.reject(error);
	})
})

Vue.prototype.axios = AxiosIns;
Vue.prototype.axiosJSON = AxiosIns2;
util.axios = AxiosIns;



// WEBPACK FOOTER //
// ./src/common/axiosSetting.js